<ng-container *ngIf="operations$ | async as operations">
  <nz-spin [nzSpinning]="loading">
    <nz-radio-group
      class="em-area"
      (ngModelChange)="operationSelectionChange($event)"
      [(ngModel)]="selectedOperation"
      nzType="flex"
      nzJustify="space-evenly"
    >
      <div
        *ngFor="let operation of operations; trackBy: trackByRef"
        nz-radio-button
        [nzValue]="operation"
      >
        <span>
          <em-display-property [value]="title">
            <ng-template #title>
              {{ operation.operationShortText }}
              <!-- <em-warning-icon
                *ngIf="failedValidations$ | async | applyPure: hasFailedValidation:operation"
              ></em-warning-icon> -->
            </ng-template>
          </em-display-property>
        </span>
      </div>
    </nz-radio-group>
  </nz-spin>

  <ng-container *ngIf="operationsUiState$ | async as uiState">
    <em-characteristics-table
      [loading]="uiState[selectedOperation?.id!]?.loading ?? loading"
      [taskListOperation]="selectedOperation"
    ></em-characteristics-table>
  </ng-container>
</ng-container>
